import React from 'react';
import PropTypes from 'prop-types';
import { FullScreen, useFullScreenHandle } from 'react-full-screen';
import Carousel from '../../../shared/components/Carousel/Carousel';
import CarouselTopBar from '../../../shared/components/Carousel/CarouselTopBar';

const ReviewCarousel = ({
  items,
  selectedItem,
  onClose,
}) => {
  const settings = {
    dots: true,
    lazyLoad: 'progressive',
    infinite: true,
    fade: false,
    speed: 500,
    autoplaySpeed: 3000,
    swipeToSlide: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: selectedItem,
    autoplay: false,
    useTransform: false,
    className: 'grid-carousel-gallery',
    nextArrow: <span className="icon-cross" />,
    prevArrow: <span className="icon-cross" />,
  };

  const handle = useFullScreenHandle();

  return (
    <FullScreen handle={handle} className="grid-gallery">
      <CarouselTopBar
        isMaximized={handle.active}
        onMaximize={handle.enter}
        onMinimize={handle.exit}
        onClosed={onClose}
      />
      <Carousel items={items} settings={settings} />
    </FullScreen>
  );
};

ReviewCarousel.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    src: PropTypes.string,
    type: PropTypes.string,
    alt: PropTypes.string,
  })).isRequired,
  selectedItem: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ReviewCarousel;
